import React, { Component } from "react";
import Proptypes from "prop-types";
import { connect } from "react-redux";
import {
  renderField,
  required,
  renderTextArea,
  number,
  renderPass,
  renderToggle,
  renderSelectField,
  renderPassTextArea,
} from "../../../../utils/formValidations.js";
import { Field, reduxForm, formValueSelector, getFormValues, getFormInitialValues } from "redux-form";
import { withRouter } from "react-router-dom";
import {withTranslation} from "react-i18next";
import { Button, FormFooter, Groups, FormField } from "../../../../components/Form"

class NutanixProviderFormTemplate extends Component {

  constructor(props) {
    super(props);
    this.state = {
      currentProvider: {},
    };
    this.submitApi = this.submitApi.bind(this);
    this.cancelButton = this.cancelButton.bind(this);
    this.updateFullClone = this.updateFullClone.bind(this);
  }

  componentDidMount() {

    let newValues = {
      ...this.props?.initial_values,
      ...this.props?.current_provider
    }
    this.props.initialize({
      ...newValues
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.current_provider && this.props.current_provider !== nextProps.current_provider) {
      this.props.initialize({
        vm_provider_config_name: nextProps.current_provider.vm_provider_config_name,
        vm_provider_name: nextProps.current_provider.vm_provider_name,
        max_instances: nextProps.current_provider.max_instances,

        host: nextProps.current_provider.host,
        port: nextProps.current_provider.port,
        username: nextProps.current_provider.username,
        password: nextProps.current_provider.password,
        verify_ssl: nextProps.current_provider.verify_ssl,

        api_version: nextProps.current_provider.api_version,

        vm_candidate: nextProps.current_provider.vm_candidate,
        cores: nextProps.current_provider.cores,
        memory: nextProps.current_provider.memory,

        startup_script: nextProps.current_provider.startup_script,
      });
    }
  }

  cancelButton() {
    this.props.cancel_button(userData)
  }

  submitApi(userData) {
    userData.vm_provider_name = "nutanix"
    this.props.submit_api(userData)
  }

  updateFullClone(event) {
    if (event.target.checked === false) {
      this.props.change('storage_pool_name', '')
    }
  }

  render() {
    const { handleSubmit, t, NutanixProviderFormValues } = this.props;

    return (
      <Groups noPadding section="providers" onSubmit={handleSubmit(this.submitApi)}>
        <FormField label="Name">
          <Field type="text"
            name="vm_provider_config_name"
            id="vm_provider_config_name"
            placeholder={t("providers.Example-Nutanix-Config")}
            component={renderField}
            validate={required} required
          />
        </FormField>

          <Field type="number"
            name="max_instances"
            id="max_instances"
            placeholder={t("10")}
            help="kb-24-nutanix-1"
            component={renderField}
            validate={number} required
          />

          <Field type="text"
            name="host"
            id="host"
            placeholder="nutanix.example.com"
            help="kb-24-nutanix-2"
            component={renderField}
            validate={required} required
          />

          <Field type="number"
            name="port"
            id="port"
            placeholder="9440"
            help="kb-24-nutanix-3"
            component={renderField}
            validate={number} required
          />

          <Field type="text"
            name="username"
            id="username"
            placeholder="admin"
            help="kb-24-nutanix-4"
            component={renderField}
            validate={required} required
          />

          <Field type="text"
            name="password"
            id="password"
            placeholder=""
            help="kb-24-nutanix-5"
            component={renderPass}
            validate={required} required
          />

          <Field type="checkbox"
            name="verify_ssl"
            id="verify_ssl"
            help="kb-24-nutanix-6"
            checked={this.props.verify_ssl && this.props.current_provider.verify_ssl}
            component={renderToggle}
          />

          <Field type="text"
            name="api_version"
            id="api_version"
            help="kb-24-nutanix-7"
            component={renderSelectField}
            validate={required} required>
              <option>{t("providers.Select")}</option>
              <option value="v3">v3</option>
              <option value="v4">v4</option>
          </Field>

          <Field type="text"
            name="vm_candidate"
            id="vm_candidate"
            placeholder="KasmVM"
            help="kb-24-nutanix-8"
            component={renderField}
            validate={required} required
          />

          <Field type="number"
            name="cores"
            id="cores"
            placeholder="2"
            help="kb-24-nutanix-9"
            component={renderField}
            validate={number} required
          />
  
          <Field type="number"
            name="memory"
            id="memory"
            placeholder="2"
            help="kb-24-nutanix-10"
            component={renderField}
            validate={required} required
          />

          <Field type="text"
            name="startup_script"
            id="startup_script"
            placeholder="#!/bin/bash&#10;..."
            help="kb-24-nutanix-11"
            component={renderTextArea}
          />

        <FormFooter
          cancelButton={<button className="cancel-button tw-bg-transparent" type="cancel" onClick={() => this.props.cancel_button()}> {this.props.wizard ? t("buttons.Previous") : t("buttons.Cancel")}</button>}
          saveButton={<Button id="save-nutanix-vm" icon="save" type="submit" section="buttons" name={!this.props.wizard ? 'Submit' : this.props.stepCount && this.props.stepCount > 2 ? t("buttons.Next") : t("buttons.Finish")} />}
        />

      </Groups>
    );
  }
}

NutanixProviderFormTemplate.propTypes = {
  current_provider: Proptypes.object,
  submit_api: Proptypes.func.isRequired,
  handleSubmit: Proptypes.func,
  cancel_button: Proptypes.func,
  NutanixProviderFormValues: Proptypes.object,
};

let NutanixProviderFormWithRouter = withRouter(NutanixProviderFormTemplate);

let NutanixProviderForm = connect(state =>
  ({
    vm_provider_configs: state.vm_provider.vm_provider_configs,
    NutanixProviderFormValues: state.form && state.form.VmProviderForm && state.form.VmProviderForm.values ? state.form.VmProviderForm.values : null,
  }), dispatch =>({}))(NutanixProviderFormWithRouter);

const NutanixProviderFormTranslated = withTranslation('common')(NutanixProviderForm)

export default reduxForm({
  form: "VmProviderForm",
})(NutanixProviderFormTranslated);
